// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel--FzgUa","slide":"slide--4LCbO","fade":"fade--1xdUB"};